import Admin from '@/generated/classes/Admin';
import { AdminConfig as AdminConfigBase } from '@/generated/classes/Admin';
import { AdminObj as AdminObjBase } from '@/generated/classes/Admin';
import { AdminExport as AdminExportBase } from '@/generated/classes/Admin';
import { AdminImport as AdminImportBase } from '@/generated/classes/Admin';
export default class AdminExtend extends Admin {
  constructor() {
    super();
  }
}
export class AdminConfig extends AdminConfigBase {
  constructor() {
    super();
  }
}
export class AdminObj extends AdminObjBase {
  constructor() {
    super();
  }
}
export class AdminExport extends AdminExportBase {
  constructor() {
    super();
  }
}
export class AdminImport extends AdminImportBase {
  constructor() {
    super();
  }
}
